// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"112":"635554de","416":"1e21d276","538":"7502cfce","545":"363a01e3","566":"162a9303","614":"084c75c7","676":"4165fea7","882":"20d37339","932":"3b32721d"}[chunkId] + ".chunk.js";
};